import { useState, useEffect, useContext } from "react";
import Select from "react-select/creatable";
import AsyncCreatableSelect from 'react-select/async-creatable';
import { FaRegStar, FaStar } from "react-icons/fa";
import { MdInfo } from 'react-icons/md';
import { TiWarningOutline } from "react-icons/ti";
import { DContext } from "../../../../context/Datacontext";
import { fetchCandidatess } from "../../../services/Candidate/fetchCandidate";
import { useNavigate } from "react-router-dom";
import { TiArrowBack } from "react-icons/ti";


// Indian states data (partial representation)
const indianStates = [
  {
    value: "andhra pradesh",
    label: "Andhra Pradesh",
    district: [
      { value: "anantapur", label: "Anantapur" },
      { value: "chittoor", label: "Chittoor" },
      { value: "east godavari", label: "East Godavari" },
      { value: "guntur", label: "Guntur" },
      { value: "krishna", label: "Krishna" },
      { value: "kurnool", label: "Kurnool" },
      { value: "prakasam", label: "Prakasam" },
      { value: "srikakulam", label: "Srikakulam" },
      { value: "sri potti sriramulu nellore", label: "Sri Potti Sriramulu Nellore" },
      { value: "visakhapatnam", label: "Visakhapatnam" },
      { value: "vizianagaram", label: "Vizianagaram" },
      { value: "west godavari", label: "West Godavari" },
      { value: "ysr", label: "YSR District, Kadapa" }
    ]
  },
  {
    value: "arunachal pradesh",
    label: "Arunachal Pradesh",
    district: [
      { value: "anjaw", label: "Anjaw" },
      { value: "changlang", label: "Changlang" },
      { value: "dibang valley", label: "Dibang Valley" },
      { value: "east kameng", label: "East Kameng" },
      { value: "east siang", label: "East Siang" },
      { value: "kamle", label: "Kamle" },
      { value: "kra daadi", label: "Kra Daadi" },
      { value: "kurung kumey", label: "Kurung Kumey" },
      { value: "lepa rada", label: "Lepa Rada" },
      { value: "lohit", label: "Lohit" },
      { value: "longding", label: "Longding" },
      { value: "lower dibang valley", label: "Lower Dibang Valley" },
      { value: "lower siang", label: "Lower Siang" },
      { value: "lower subansiri", label: "Lower Subansiri" },
      { value: "namsai", label: "Namsai" },
      { value: "pakke kessang", label: "Pakke Kessang" },
      { value: "papum pare", label: "Papum Pare" },
      { value: "shi yomi", label: "Shi Yomi" },
      { value: "siang", label: "Siang" },
      { value: "tawang", label: "Tawang" },
      { value: "tirap", label: "Tirap" },
      { value: "upper siang", label: "Upper Siang" },
      { value: "upper subansiri", label: "Upper Subansiri" },
      { value: "west kameng", label: "West Kameng" },
      { value: "west siang", label: "West Siang" }
    ]
  },
  {
    value: "assam",
    label: "Assam",
    district: [
      { value: "baksa", label: "Baksa" },
      { value: "barpeta", label: "Barpeta" },
      { value: "biswanath", label: "Biswanath" },
      { value: "bongaigaon", label: "Bongaigaon" },
      { value: "cachar", label: "Cachar" },
      { value: "charaideo", label: "Charaideo" },
      { value: "chirang", label: "Chirang" },
      { value: "darrang", label: "Darrang" },
      { value: "dhemaji", label: "Dhemaji" },
      { value: "dhubri", label: "Dhubri" },
      { value: "dibrugarh", label: "Dibrugarh" },
      { value: "dima hasao", label: "Dima Hasao" },
      { value: "goalpara", label: "Goalpara" },
      { value: "golaghat", label: "Golaghat" },
      { value: "hailakandi", label: "Hailakandi" },
      { value: "hojai", label: "Hojai" },
      { value: "jorhat", label: "Jorhat" },
      { value: "kamrup", label: "Kamrup" },
      { value: "kamrup metropolitan", label: "Kamrup Metropolitan" },
      { value: "karbi anglong", label: "Karbi Anglong" },
      { value: "karimganj", label: "Karimganj" },
      { value: "kokrajhar", label: "Kokrajhar" },
      { value: "lakhimpur", label: "Lakhimpur" },
      { value: "majuli", label: "Majuli" },
      { value: "morigaon", label: "Morigaon" },
      { value: "nagaon", label: "Nagaon" },
      { value: "nalbari", label: "Nalbari" },
      { value: "sivasagar", label: "Sivasagar" },
      { value: "sonitpur", label: "Sonitpur" },
      { value: "south salmara mankachar", label: "South Salmara-Mankachar" },
      { value: "tinsukia", label: "Tinsukia" },
      { value: "udalguri", label: "Udalguri" },
      { value: "west karbi anglong", label: "West Karbi Anglong" }
    ]
  },
  {
    value: "bihar",
    label: "Bihar",
    district: [
      { value: "araria", label: "Araria" },
      { value: "arwal", label: "Arwal" },
      { value: "aurangabad", label: "Aurangabad" },
      { value: "banka", label: "Banka" },
      { value: "begusarai", label: "Begusarai" },
      { value: "bhagalpur", label: "Bhagalpur" },
      { value: "bhojpur", label: "Bhojpur" },
      { value: "buxar", label: "Buxar" },
      { value: "darbhanga", label: "Darbhanga" },
      { value: "east champaran", label: "East Champaran" },
      { value: "gaya", label: "Gaya" },
      { value: "gopalganj", label: "Gopalganj" },
      { value: "jamui", label: "Jamui" },
      { value: "jehanabad", label: "Jehanabad" },
      { value: "kaimur", label: "Kaimur" },
      { value: "katihar", label: "Katihar" },
      { value: "khagaria", label: "Khagaria" },
      { value: "kishanganj", label: "Kishanganj" },
      { value: "lakhisarai", label: "Lakhisarai" },
      { value: "madhepura", label: "Madhepura" },
      { value: "madhubani", label: "Madhubani" },
      { value: "munger", label: "Munger" },
      { value: "muzaffarpur", label: "Muzaffarpur" },
      { value: "nalanda", label: "Nalanda" },
      { value: "nawada", label: "Nawada" },
      { value: "patna", label: "Patna" },
      { value: "purnia", label: "Purnia" },
      { value: "rohtas", label: "Rohtas" },
      { value: "saharsa", label: "Saharsa" },
      { value: "samastipur", label: "Samastipur" },
      { value: "saran", label: "Saran" },
      { value: "sheikhpura", label: "Sheikhpura" },
      { value: "sheohar", label: "Sheohar" },
      { value: "sitamarhi", label: "Sitamarhi" },
      { value: "siwan", label: "Siwan" },
      { value: "supaul", label: "Supaul" },
      { value: "vaishali", label: "Vaishali" },
      { value: "west champaran", label: "West Champaran" }
    ]
  },
  {
    value: "chhattisgarh",
    label: "Chhattisgarh",
    district: [
      { value: "balod", label: "Balod" },
      { value: "baloda bazar", label: "Baloda Bazar" },
      { value: "balrampur", label: "Balrampur" },
      { value: "bastar", label: "Bastar" },
      { value: "bemetara", label: "Bemetara" },
      { value: "bijapur", label: "Bijapur" },
      { value: "bilaspur", label: "Bilaspur" },
      { value: "dantewada", label: "Dantewada" },
      { value: "dhamtari", label: "Dhamtari" },
      { value: "durg", label: "Durg" },
      { value: "gariaband", label: "Gariaband" },
      { value: "janjgir champa", label: "Janjgir-Champa" },
      { value: "jashpur", label: "Jashpur" },
      { value: "kabirdham", label: "Kabirdham" },
      { value: "kanker", label: "Kanker" },
      { value: "kondagaon", label: "Kondagaon" },
      { value: "korba", label: "Korba" },
      { value: "koriya", label: "Koriya" },
      { value: "mahasamund", label: "Mahasamund" },
      { value: "mungeli", label: "Mungeli" },
      { value: "narayanpur", label: "Narayanpur" },
      { value: "raigarh", label: "Raigarh" },
      { value: "raipur", label: "Raipur" },
      { value: "rajnandgaon", label: "Rajnandgaon" },
      { value: "sukma", label: "Sukma" },
      { value: "surajpur", label: "Surajpur" },
      { value: "surguja", label: "Surguja" }
    ]
  },
  {
    value: "goa",
    label: "Goa",
    district: [
      { value: "north goa", label: "North Goa" },
      { value: "south goa", label: "South Goa" }
    ]
  },
  {
    value: "gujarat",
    label: "Gujarat",
    district: [
      { value: "ahmedabad", label: "Ahmedabad" },
      { value: "amreli", label: "Amreli" },
      { value: "anand", label: "Anand" },
      { value: "aravalli", label: "Aravalli" },
      { value: "banaskantha", label: "Banaskantha" },
      { value: "bharuch", label: "Bharuch" },
      { value: "bhavnagar", label: "Bhavnagar" },
      { value: "botad", label: "Botad" },
      { value: "chhota udaipur", label: "Chhota Udaipur" },
      { value: "dahod", label: "Dahod" },
      { value: "dang", label: "Dang" },
      { value: "devbhoomi dwarka", label: "Devbhoomi Dwarka" },
      { value: "gandhinagar", label: "Gandhinagar" },
      { value: "gir somnath", label: "Gir Somnath" },
      { value: "jamnagar", label: "Jamnagar" },
      { value: "junagadh", label: "Junagadh" },
      { value: "kheda", label: "Kheda" },
      { value: "kutch", label: "Kutch" },
      { value: "mahisagar", label: "Mahisagar" },
      { value: "mehsana", label: "Mehsana" },
      { value: "morbi", label: "Morbi" },
      { value: "narmada", label: "Narmada" },
      { value: "navsari", label: "Navsari" },
      { value: "panchmahal", label: "Panchmahal" },
      { value: "patan", label: "Patan" },
      { value: "porbandar", label: "Porbandar" },
      { value: "rajkot", label: "Rajkot" },
      { value: "sabarkantha", label: "Sabarkantha" },
      { value: "surat", label: "Surat" },
      { value: "surendranagar", label: "Surendranagar" },
      { value: "tapi", label: "Tapi" },
      { value: "vadodara", label: "Vadodara" },
      { value: "valsad", label: "Valsad" }
    ]
  },
  {
    value: "haryana",
    label: "Haryana",
    district: [
      { value: "ambala", label: "Ambala" },
      { value: "bhiwani", label: "Bhiwani" },
      { value: "charkhi dadri", label: "Charkhi Dadri" },
      { value: "faridabad", label: "Faridabad" },
      { value: "fatehabad", label: "Fatehabad" },
      { value: "gurugram", label: "Gurugram" },
      { value: "hisar", label: "Hisar" },
      { value: "jhajjar", label: "Jhajjar" },
      { value: "jind", label: "Jind" },
      { value: "kaithal", label: "Kaithal" },
      { value: "karnal", label: "Karnal" },
      { value: "kurukshetra", label: "Kurukshetra" },
      { value: "mahendragarh", label: "Mahendragarh" },
      { value: "nuh", label: "Nuh" },
      { value: "palwal", label: "Palwal" },
      { value: "panchkula", label: "Panchkula" },
      { value: "panipat", label: "Panipat" },
      { value: "rewari", label: "Rewari" },
      { value: "rohtak", label: "Rohtak" },
      { value: "sirsa", label: "Sirsa" },
      { value: "sonipat", label: "Sonipat" },
      { value: "yamunanagar", label: "Yamunanagar" }
    ]
  },
  {
    value: "himachal pradesh",
    label: "Himachal Pradesh",
    district: [
      { value: "bilaspur", label: "Bilaspur" },
      { value: "chamba", label: "Chamba" },
      { value: "hamirpur", label: "Hamirpur" },
      { value: "kangra", label: "Kangra" },
      { value: "kinnaur", label: "Kinnaur" },
      { value: "kullu", label: "Kullu" },
      { value: "lahaul and spiti", label: "Lahaul and Spiti" },
      { value: "mandi", label: "Mandi" },
      { value: "shimla", label: "Shimla" },
      { value: "sirmaur", label: "Sirmaur" },
      { value: "solan", label: "Solan" },
      { value: "una", label: "Una" }
    ]
  },
  {
    value: "jharkhand",
    label: "Jharkhand",
    district: [
      { value: "bokaro", label: "Bokaro" },
      { value: "chatra", label: "Chatra" },
      { value: "deoghar", label: "Deoghar" },
      { value: "dhanbad", label: "Dhanbad" },
      { value: "dumka", label: "Dumka" },
      { value: "east singhbhum", label: "East Singhbhum" },
      { value: "garhwa", label: "Garhwa" },
      { value: "giridih", label: "Giridih" },
      { value: "godda", label: "Godda" },
      { value: "gumla", label: "Gumla" },
      { value: "hazaribagh", label: "Hazaribagh" },
      { value: "jamtara", label: "Jamtara" },
      { value: "khunti", label: "Khunti" },
      { value: "koderma", label: "Koderma" },
      { value: "latehar", label: "Latehar" },
      { value: "lohardaga", label: "Lohardaga" },
      { value: "pakur", label: "Pakur" },
      { value: "palamu", label: "Palamu" },
      { value: "ramgarh", label: "Ramgarh" },
      { value: "ranchi", label: "Ranchi" },
      { value: "sahibganj", label: "Sahibganj" },
      { value: "seraikela kharsawan", label: "Seraikela Kharsawan" },
      { value: "simdega", label: "Simdega" },
      { value: "west singhbhum", label: "West Singhbhum" }
    ]
  },
  {
    value: "karnataka",
    label: "Karnataka",
    district: [
      { value: "bagalkot", label: "Bagalkot" },
      { value: "ballari", label: "Ballari" },
      { value: "belagavi", label: "Belagavi" },
      { value: "bengaluru rural", label: "Bengaluru Rural" },
      { value: "bengaluru urban", label: "Bengaluru Urban" },
      { value: "bidar", label: "Bidar" },
      { value: "chamarajanagar", label: "Chamarajanagar" },
      { value: "chikballapur", label: "Chikballapur" },
      { value: "chikkamagaluru", label: "Chikkamagaluru" },
      { value: "chitradurga", label: "Chitradurga" },
      { value: "dakshina kannada", label: "Dakshina Kannada" },
      { value: "davangere", label: "Davangere" },
      { value: "dharwad", label: "Dharwad" },
      { value: "gadag", label: "Gadag" },
      { value: "hassan", label: "Hassan" },
      { value: "haveri", label: "Haveri" },
      { value: "kalaburagi", label: "Kalaburagi" },
      { value: "kodagu", label: "Kodagu" },
      { value: "kolar", label: "Kolar" },
      { value: "koppal", label: "Koppal" },
      { value: "mandya", label: "Mandya" },
      { value: "mysuru", label: "Mysuru" },
      { value: "raichur", label: "Raichur" },
      { value: "ramanagara", label: "Ramanagara" },
      { value: "shivamogga", label: "Shivamogga" },
      { value: "tumakuru", label: "Tumakuru" },
      { value: "udupi", label: "Udupi" },
      { value: "uttara kannada", label: "Uttara Kannada" },
      { value: "vijayapura", label: "Vijayapura" },
      { value: "yadgir", label: "Yadgir" }
    ]
  },
  {
    value: "kerala",
    label: "Kerala",
    district: [
      { value: "alappuzha", label: "Alappuzha" },
      { value: "ernakulam", label: "Ernakulam" },
      { value: "idukki", label: "Idukki" },
      { value: "kannur", label: "Kannur" },
      { value: "kasaragod", label: "Kasaragod" },
      { value: "kollam", label: "Kollam" },
      { value: "kottayam", label: "Kottayam" },
      { value: "kozhikode", label: "Kozhikode" },
      { value: "malappuram", label: "Malappuram" },
      { value: "palakkad", label: "Palakkad" },
      { value: "pathanamthitta", label: "Pathanamthitta" },
      { value: "thiruvananthapuram", label: "Thiruvananthapuram" },
      { value: "thrissur", label: "Thrissur" },
      { value: "wayanad", label: "Wayanad" }
    ]
  },
  {
    value: "madhya pradesh",
    label: "Madhya Pradesh",
    district: [
      { value: "agar malwa", label: "Agar Malwa" },
      { value: "alirajpur", label: "Alirajpur" },
      { value: "anuppur", label: "Anuppur" },
      { value: "ashoknagar", label: "Ashoknagar" },
      { value: "balaghat", label: "Balaghat" },
      { value: "barwani", label: "Barwani" },
      { value: "betul", label: "Betul" },
      { value: "bhind", label: "Bhind" },
      { value: "bhopal", label: "Bhopal" },
      { value: "burhanpur", label: "Burhanpur" },
      { value: "chhatarpur", label: "Chhatarpur" },
      { value: "chhindwara", label: "Chhindwara" },
      { value: "damoh", label: "Damoh" },
      { value: "datia", label: "Datia" },
      { value: "dewas", label: "Dewas" },
      { value: "dhar", label: "Dhar" },
      { value: "dindori", label: "Dindori" },
      { value: "guna", label: "Guna" },
      { value: "gwalior", label: "Gwalior" },
      { value: "harda", label: "Harda" },
      { value: "hoshangabad", label: "Hoshangabad" },
      { value: "indore", label: "Indore" },
      { value: "jabalpur", label: "Jabalpur" },
      { value: "jhabua", label: "Jhabua" },
      { value: "katni", label: "Katni" },
      { value: "khandwa", label: "Khandwa" },
      { value: "khargone", label: "Khargone" },
      { value: "mandla", label: "Mandla" },
      { value: "mandsaur", label: "Mandsaur" },
      { value: "morena", label: "Morena" },
      { value: "narsinghpur", label: "Narsinghpur" },
      { value: "neemuch", label: "Neemuch" },
      { value: "panna", label: "Panna" },
      { value: "raisen", label: "Raisen" },
      { value: "rajgarh", label: "Rajgarh" },
      { value: "ratlam", label: "Ratlam" },
      { value: "rewa", label: "Rewa" },
      { value: "sagar", label: "Sagar" },
      { value: "satna", label: "Satna" },
      { value: "sehore", label: "Sehore" },
      { value: "seoni", label: "Seoni" },
      { value: "shahdol", label: "Shahdol" },
      { value: "shajapur", label: "Shajapur" },
      { value: "sheopur", label: "Sheopur" },
      { value: "shivpuri", label: "Shivpuri" },
      { value: "sidhi", label: "Sidhi" },
      { value: "singrauli", label: "Singrauli" },
      { value: "tikamgarh", label: "Tikamgarh" },
      { value: "ujjain", label: "Ujjain" },
      { value: "umaria", label: "Umaria" },
      { value: "vidisha", label: "Vidisha" }
    ]
  },
  {
    value: "maharashtra",
    label: "Maharashtra",
    district: [
      { value: "ahmednagar", label: "Ahmednagar" },
      { value: "akola", label: "Akola" },
      { value: "amravati", label: "Amravati" },
      { value: "aurangabad", label: "Aurangabad" },
      { value: "beed", label: "Beed" },
      { value: "bhandara", label: "Bhandara" },
      { value: "buldhana", label: "Buldhana" },
      { value: "chandrapur", label: "Chandrapur" },
      { value: "dhule", label: "Dhule" },
      { value: "gadchiroli", label: "Gadchiroli" },
      { value: "gondia", label: "Gondia" },
      { value: "hingoli", label: "Hingoli" },
      { value: "jalgaon", label: "Jalgaon" },
      { value: "jalna", label: "Jalna" },
      { value: "kolhapur", label: "Kolhapur" },
      { value: "latur", label: "Latur" },
      { value: "mumbai city", label: "Mumbai City" },
      { value: "mumbai suburban", label: "Mumbai Suburban" },
      { value: "nagpur", label: "Nagpur" },
      { value: "nanded", label: "Nanded" },
      { value: "nandurbar", label: "Nandurbar" },
      { value: "nashik", label: "Nashik" },
      { value: "osmanabad", label: "Osmanabad" },
      { value: "palghar", label: "Palghar" },
      { value: "parbhani", label: "Parbhani" },
      { value: "pune", label: "Pune" },
      { value: "raigad", label: "Raigad" },
      { value: "ratnagiri", label: "Ratnagiri" },
      { value: "sangli", label: "Sangli" },
      { value: "satara", label: "Satara" },
      { value: "sindhudurg", label: "Sindhudurg" },
      { value: "solapur", label: "Solapur" },
      { value: "thane", label: "Thane" },
      { value: "wardha", label: "Wardha" },
      { value: "washim", label: "Washim" },
      { value: "yavatmal", label: "Yavatmal" }
    ]
  },
  {
    value: "manipur",
    label: "Manipur",
    district: [
      { value: "bishnupur", label: "Bishnupur" },
      { value: "chandel", label: "Chandel" },
      { value: "churachandpur", label: "Churachandpur" },
      { value: "imphal east", label: "Imphal East" },
      { value: "imphal west", label: "Imphal West" },
      { value: "jiribam", label: "Jiribam" },
      { value: "kakching", label: "Kakching" },
      { value: "kamjong", label: "Kamjong" },
      { value: "kangpokpi", label: "Kangpokpi" },
      { value: "noney", label: "Noney" },
      { value: "pherzawl", label: "Pherzawl" },
      { value: "senapati", label: "Senapati" },
      { value: "tamenglong", label: "Tamenglong" },
      { value: "tengnoupal", label: "Tengnoupal" },
      { value: "thoubal", label: "Thoubal" },
      { value: "ukhrul", label: "Ukhrul" }
    ]
  },
  {
    value: "meghalaya",
    label: "Meghalaya",
    district: [
      { value: "east garo hills", label: "East Garo Hills" },
      { value: "east jaintia hills", label: "East Jaintia Hills" },
      { value: "east khasi hills", label: "East Khasi Hills" },
      { value: "north garo hills", label: "North Garo Hills" },
      { value: "ri bhoi", label: "Ri Bhoi" },
      { value: "south garo hills", label: "South Garo Hills" },
      { value: "south west garo hills", label: "South West Garo Hills" },
      { value: "south west khasi hills", label: "South West Khasi Hills" },
      { value: "west garo hills", label: "West Garo Hills" },
      { value: "west jaintia hills", label: "West Jaintia Hills" },
      { value: "west khasi hills", label: "West Khasi Hills" }
    ]
  },
  {
    value: "mizoram",
    label: "Mizoram",
    district: [
      { value: "aizawl", label: "Aizawl" },
      { value: "champhai", label: "Champhai" },
      { value: "hnahthial", label: "Hnahthial" },
      { value: "khawzawl", label: "Khawzawl" },
      { value: "kolasib", label: "Kolasib" },
      { value: "lawngtlai", label: "Lawngtlai" },
      { value: "lunglei", label: "Lunglei" },
      { value: "mamit", label: "Mamit" },
      { value: "saiha", label: "Saiha" },
      { value: "saitual", label: "Saitual" },
      { value: "serchhip", label: "Serchhip" }
    ]
  },
  {
    value: "nagaland",
    label: "Nagaland",
    district: [
      { value: "dimapur", label: "Dimapur" },
      { value: "kiphire", label: "Kiphire" },
      { value: "kohima", label: "Kohima" },
      { value: "longleng", label: "Longleng" },
      { value: "mokokchung", label: "Mokokchung" },
      { value: "mon", label: "Mon" },
      { value: "noklak", label: "Noklak" },
      { value: "peren", label: "Peren" },
      { value: "phek", label: "Phek" },
      { value: "tuensang", label: "Tuensang" },
      { value: "wokha", label: "Wokha" },
      { value: "zunheboto", label: "Zunheboto" }
    ]
  },
  {
    value: "odisha",
    label: "Odisha",
    district: [
      { value: "angul", label: "Angul" },
      { value: "balangir", label: "Balangir" },
      { value: "balasore", label: "Balasore" },
      { value: "bargarh", label: "Bargarh" },
      { value: "bhadrak", label: "Bhadrak" },
      { value: "boudh", label: "Boudh" },
      { value: "cuttack", label: "Cuttack" },
      { value: "deogarh", label: "Deogarh" },
      { value: "dhenkanal", label: "Dhenkanal" },
      { value: "gajapati", label: "Gajapati" },
      { value: "ganjam", label: "Ganjam" },
      { value: "jagatsinghpur", label: "Jagatsinghpur" },
      { value: "jajpur", label: "Jajpur" },
      { value: "jharsuguda", label: "Jharsuguda" },
      { value: "kalahandi", label: "Kalahandi" },
      { value: "kandhamal", label: "Kandhamal" },
      { value: "kendrapara", label: "Kendrapara" },
      { value: "kendujhar", label: "Kendujhar" },
      { value: "khordha", label: "Khordha" },
      { value: "koraput", label: "Koraput" },
      { value: "malkangiri", label: "Malkangiri" },
      { value: "mayurbhanj", label: "Mayurbhanj" },
      { value: "nabarangpur", label: "Nabarangpur" },
      { value: "nayagarh", label: "Nayagarh" },
      { value: "nuapada", label: "Nuapada" },
      { value: "puri", label: "Puri" },
      { value: "rayagada", label: "Rayagada" },
      { value: "sambalpur", label: "Sambalpur" },
      { value: "subarnapur", label: "Subarnapur" },
      { value: "sundargarh", label: "Sundargarh" }
    ]
  },
  {
    value: "punjab",
    label: "Punjab",
    district: [
      { value: "amritsar", label: "Amritsar" },
      { value: "barnala", label: "Barnala" },
      { value: "bathinda", label: "Bathinda" },
      { value: "faridkot", label: "Faridkot" },
      { value: "fatehgarh sahib", label: "Fatehgarh Sahib" },
      { value: "fazilka", label: "Fazilka" },
      { value: "ferozepur", label: "Ferozepur" },
      { value: "gurdaspur", label: "Gurdaspur" },
      { value: "hoshiarpur", label: "Hoshiarpur" },
      { value: "jalandhar", label: "Jalandhar" },
      { value: "kapurthala", label: "Kapurthala" },
      { value: "ludhiana", label: "Ludhiana" },
      { value: "mansa", label: "Mansa" },
      { value: "moga", label: "Moga" },
      { value: "mohali", label: "Mohali" },
      { value: "muktsar", label: "Muktsar" },
      { value: "pathankot", label: "Pathankot" },
      { value: "patiala", label: "Patiala" },
      { value: "rupnagar", label: "Rupnagar" },
      { value: "sangrur", label: "Sangrur" },
      { value: "shaheed bhagat singh nagar", label: "Shaheed Bhagat Singh Nagar" },
      { value: "tarn taran", label: "Tarn Taran" }
    ]
  },
  {
    value: "rajasthan",
    label: "Rajasthan",
    district: [
      { value: "ajmer", label: "Ajmer" },
      { value: "alwar", label: "Alwar" },
      { value: "banswara", label: "Banswara" },
      { value: "baran", label: "Baran" },
      { value: "barmer", label: "Barmer" },
      { value: "bharatpur", label: "Bharatpur" },
      { value: "bhilwara", label: "Bhilwara" },
      { value: "bikaner", label: "Bikaner" },
      { value: "bundi", label: "Bundi" },
      { value: "chittorgarh", label: "Chittorgarh" },
      { value: "churu", label: "Churu" },
      { value: "dausa", label: "Dausa" },
      { value: "dholpur", label: "Dholpur" },
      { value: "dungarpur", label: "Dungarpur" },
      { value: "hanumangarh", label: "Hanumangarh" },
      { value: "jaipur", label: "Jaipur" },
      { value: "jaisalmer", label: "Jaisalmer" },
      { value: "jalore", label: "Jalore" },
      { value: "jhalawar", label: "Jhalawar" },
      { value: "jhunjhunu", label: "Jhunjhunu" },
      { value: "jodhpur", label: "Jodhpur" },
      { value: "karauli", label: "Karauli" },
      { value: "kota", label: "Kota" },
      { value: "nagaur", label: "Nagaur" },
      { value: "pali", label: "Pali" },
      { value: "pratapgarh", label: "Pratapgarh" },
      { value: "rajsamand", label: "Rajsamand" },
      { value: "sawai madhopur", label: "Sawai Madhopur" },
      { value: "sikar", label: "Sikar" },
      { value: "sirohi", label: "Sirohi" },
      { value: "sri ganganagar", label: "Sri Ganganagar" },
      { value: "tonk", label: "Tonk" },
      { value: "udaipur", label: "Udaipur" }
    ]
  },
  {
    value: "sikkim",
    label: "Sikkim",
    district: [
      { value: "east sikkim", label: "East Sikkim" },
      { value: "north sikkim", label: "North Sikkim" },
      { value: "south sikkim", label: "South Sikkim" },
      { value: "west sikkim", label: "West Sikkim" }
    ]
  },
  {
    value: "tamil nadu",
    label: "Tamil Nadu",
    district: [
      { value: "ariyalur", label: "Ariyalur" },
      { value: "chengalpattu", label: "Chengalpattu" },
      { value: "chennai", label: "Chennai" },
      { value: "coimbatore", label: "Coimbatore" },
      { value: "cuddalore", label: "Cuddalore" },
      { value: "dharmapuri", label: "Dharmapuri" },
      { value: "dindigul", label: "Dindigul" },
      { value: "erode", label: "Erode" },
      { value: "kallakurichi", label: "Kallakurichi" },
      { value: "kanchipuram", label: "Kanchipuram" },
      { value: "kanyakumari", label: "Kanyakumari" },
      { value: "karur", label: "Karur" },
      { value: "krishnagiri", label: "Krishnagiri" },
      { value: "madurai", label: "Madurai" },
      { value: "mayiladuthurai", label: "Mayiladuthurai" },
      { value: "nagapattinam", label: "Nagapattinam" },
      { value: "namakkal", label: "Namakkal" },
      { value: "nilgiris", label: "Nilgiris" },
      { value: "perambalur", label: "Perambalur" },
      { value: "pudukkottai", label: "Pudukkottai" },
      { value: "ramanathapuram", label: "Ramanathapuram" },
      { value: "ranipet", label: "Ranipet" },
      { value: "salem", label: "Salem" },
      { value: "sivaganga", label: "Sivaganga" },
      { value: "tenkasi", label: "Tenkasi" },
      { value: "thanjavur", label: "Thanjavur" },
      { value: "theni", label: "Theni" },
      { value: "thoothukudi", label: "Thoothukudi" },
      { value: "tiruchirappalli", label: "Tiruchirappalli" },
      { value: "tirunelveli", label: "Tirunelveli" },
      { value: "tirupathur", label: "Tirupathur" },
      { value: "tiruppur", label: "Tiruppur" },
      { value: "tiruvallur", label: "Tiruvallur" },
      { value: "tiruvannamalai", label: "Tiruvannamalai" },
      { value: "tiruvarur", label: "Tiruvarur" },
      { value: "vellore", label: "Vellore" },
      { value: "viluppuram", label: "Viluppuram" },
      { value: "virudhunagar", label: "Virudhunagar" }
    ]
  },
  {
    value: "telangana",
    label: "Telangana",
    district: [
      { value: "adilabad", label: "Adilabad" },
      { value: "bhadradri kothagudem", label: "Bhadradri Kothagudem" },
      { value: "hyderabad", label: "Hyderabad" },
      { value: "jagtial", label: "Jagtial" },
      { value: "jangaon", label: "Jangaon" },
      { value: "jayashankar bhupalpally", label: "Jayashankar Bhupalpally" },
      { value: "jogulamba gadwal", label: "Jogulamba Gadwal" },
      { value: "kamareddy", label: "Kamareddy" },
      { value: "karimnagar", label: "Karimnagar" },
      { value: "khammam", label: "Khammam" },
      { value: "komaram bheem asifabad", label: "Komaram Bheem Asifabad" },
      { value: "mahabubabad", label: "Mahabubabad" },
      { value: "mahabubnagar", label: "Mahabubnagar" },
      { value: "mancherial", label: "Mancherial" },
      { value: "medak", label: "Medak" },
      { value: "medchal malkajgiri", label: "Medchal-Malkajgiri" },
      { value: "mulugu", label: "Mulugu" },
      { value: "nagarkurnool", label: "Nagarkurnool" },
      { value: "nalgonda", label: "Nalgonda" },
      { value: "narayanpet", label: "Narayanpet" },
      { value: "nirmal", label: "Nirmal" },
      { value: "nizamabad", label: "Nizamabad" },
      { value: "peddapalli", label: "Peddapalli" },
      { value: "rajanna sircilla", label: "Rajanna Sircilla" },
      { value: "rangareddy", label: "Rangareddy" },
      { value: "sangareddy", label: "Sangareddy" },
      { value: "siddipet", label: "Siddipet" },
      { value: "suryapet", label: "Suryapet" },
      { value: "vikarabad", label: "Vikarabad" },
      { value: "wanaparthy", label: "Wanaparthy" },
      { value: "warangal rural", label: "Warangal Rural" },
      { value: "warangal urban", label: "Warangal Urban" },
      { value: "yadadri bhuvanagiri", label: "Yadadri Bhuvanagiri" }
    ]
  },
  {
    value: "tripura",
    label: "Tripura",
    district: [
      { value: "dhalai", label: "Dhalai" },
      { value: "gomati", label: "Gomati" },
      { value: "khowai", label: "Khowai" },
      { value: "north tripura", label: "North Tripura" },
      { value: "sepahijala", label: "Sepahijala" },
      { value: "south tripura", label: "South Tripura" },
      { value: "unakoti", label: "Unakoti" },
      { value: "west tripura", label: "West Tripura" }
    ]
  },
  {
    value: "uttar pradesh",
    label: "Uttar Pradesh",
    district: [
      { value: "agra", label: "Agra" },
      { value: "aligarh", label: "Aligarh" },
      { value: "ambedkar nagar", label: "Ambedkar Nagar" },
      { value: "amethi", label: "Amethi" },
      { value: "amroha", label: "Amroha" },
      { value: "auraiya", label: "Auraiya" },
      { value: "azamgarh", label: "Azamgarh" },
      { value: "baghpat", label: "Baghpat" },
      { value: "bahraich", label: "Bahraich" },
      { value: "ballia", label: "Ballia" },
      { value: "balrampur", label: "Balrampur" },
      { value: "banda", label: "Banda" },
      { value: "barabanki", label: "Barabanki" },
      { value: "bareilly", label: "Bareilly" },
      { value: "basti", label: "Basti" },
      { value: "bhadohi", label: "Bhadohi" },
      { value: "bijnor", label: "Bijnor" },
      { value: "budaun", label: "Budaun" },
      { value: "bulandshahr", label: "Bulandshahr" },
      { value: "chandauli", label: "Chandauli" },
      { value: "chitrakoot", label: "Chitrakoot" },
      { value: "deoria", label: "Deoria" },
      { value: "etah", label: "Etah" },
      { value: "etawah", label: "Etawah" },
      { value: "ayodhya", label: "Ayodhya" },
      { value: "farrukhabad", label: "Farrukhabad" },
      { value: "fatehpur", label: "Fatehpur" },
      { value: "firozabad", label: "Firozabad" },
      { value: "gautam buddha nagar", label: "Gautam Buddha Nagar" },
      { value: "ghaziabad", label: "Ghaziabad" },
      { value: "ghazipur", label: "Ghazipur" },
      { value: "gonda", label: "Gonda" },
      { value: "gorakhpur", label: "Gorakhpur" },
      { value: "hamirpur", label: "Hamirpur" },
      { value: "hapur", label: "Hapur" },
      { value: "hardoi", label: "Hardoi" },
      { value: "hathras", label: "Hathras" },
      { value: "jalaun", label: "Jalaun" },
      { value: "jaunpur", label: "Jaunpur" },
      { value: "jhansi", label: "Jhansi" },
      { value: "kannauj", label: "Kannauj" },
      { value: "kanpur dehat", label: "Kanpur Dehat" },
      { value: "kanpur nagar", label: "Kanpur Nagar" },
      { value: "kasganj", label: "Kasganj" },
      { value: "kaushambi", label: "Kaushambi" },
      { value: "kheri", label: "Kheri" },
      { value: "kushinagar", label: "Kushinagar" },
      { value: "lalitpur", label: "Lalitpur" },
      { value: "lucknow", label: "Lucknow" },
      { value: "maharajganj", label: "Maharajganj" },
      { value: "mahoba", label: "Mahoba" },
      { value: "mainpuri", label: "Mainpuri" },
      { value: "mathura", label: "Mathura" },
      { value: "mau", label: "Mau" },
      { value: "meerut", label: "Meerut" },
      { value: "mirzapur", label: "Mirzapur" },
      { value: "moradabad", label: "Moradabad" },
      { value: "muzaffarnagar", label: "Muzaffarnagar" },
      { value: "pilibhit", label: "Pilibhit" },
      { value: "pratapgarh", label: "Pratapgarh" },
      { value: "prayagraj", label: "Prayagraj" },
      { value: "raebareli", label: "Raebareli" },
      { value: "rampur", label: "Rampur" },
      { value: "saharanpur", label: "Saharanpur" },
      { value: "sambhal", label: "Sambhal" },
      { value: "sant kabir nagar", label: "Sant Kabir Nagar" },
      { value: "shahjahanpur", label: "Shahjahanpur" },
      { value: "shamli", label: "Shamli" },
      { value: "shravasti", label: "Shravasti" },
      { value: "siddharthnagar", label: "Siddharthnagar" },
      { value: "sitapur", label: "Sitapur" },
      { value: "sonbhadra", label: "Sonbhadra" },
      { value: "sultanpur", label: "Sultanpur" },
      { value: "unnao", label: "Unnao" },
      { value: "varanasi", label: "Varanasi" }
    ]
  },
  {
    value: "uttarakhand",
    label: "Uttarakhand",
    district: [
      { value: "almora", label: "Almora" },
      { value: "bageshwar", label: "Bageshwar" },
      { value: "chamoli", label: "Chamoli" },
      { value: "champawat", label: "Champawat" },
      { value: "dehradun", label: "Dehradun" },
      { value: "haridwar", label: "Haridwar" },
      { value: "nainital", label: "Nainital" },
      { value: "pauri garhwal", label: "Pauri Garhwal" },
      { value: "pithoragarh", label: "Pithoragarh" },
      { value: "rudraprayag", label: "Rudraprayag" },
      { value: "tehri garhwal", label: "Tehri Garhwal" },
      { value: "udham singh nagar", label: "Udham Singh Nagar" },
      { value: "uttarkashi", label: "Uttarkashi" }
    ]
  },
  {
    value: "west bengal",
    label: "West Bengal",
    district: [
      { value: "alipurduar", label: "Alipurduar" },
      { value: "bankura", label: "Bankura" },
      { value: "birbhum", label: "Birbhum" },
      { value: "cooch behar", label: "Cooch Behar" },
      { value: "dakshin dinajpur", label: "Dakshin Dinajpur" },
      { value: "darjeeling", label: "Darjeeling" },
      { value: "hooghly", label: "Hooghly" },
      { value: "howrah", label: "Howrah" },
      { value: "jalpaiguri", label: "Jalpaiguri" },
      { value: "jhargram", label: "Jhargram" },
      { value: "kalimpong", label: "Kalimpong" },
      { value: "kolkata", label: "Kolkata" },
      { value: "malda", label: "Malda" },
      { value: "murshidabad", label: "Murshidabad" },
      { value: "nadia", label: "Nadia" },
      { value: "north 24 parganas", label: "North 24 Parganas" },
      { value: "paschim medinipur", label: "Paschim Medinipur" },
      { value: "paschim burdwan", label: "Paschim Burdwan" },
      { value: "purba burdwan", label: "Purba Burdwan" },
      { value: "purba medinipur", label: "Purba Medinipur" },
      { value: "purulia", label: "Purulia" },
      { value: "south 24 parganas", label: "South 24 Parganas" },
      { value: "uttar dinajpur", label: "Uttar Dinajpur" }
    ]
  },
  // Union Territories
  {
    value: "andaman",
    label: "Andaman and Nicobar Islands",
    district: [
      { value: "nicobar", label: "Nicobar" },
      { value: "north and middle andaman", label: "North and Middle Andaman" },
      { value: "south andaman", label: "South Andaman" }
    ]
  },
  {
    value: "chandigarh",
    label: "Chandigarh",
    district: [
      { value: "chandigarh", label: "Chandigarh" }
    ]
  },
  {
    value: "dadra and nagar haveli and daman and diu",
    label: "Dadra and Nagar Haveli and Daman and Diu",
    district: [
      { value: "dadra and nagar haveli", label: "Dadra and Nagar Haveli" },
      { value: "daman", label: "Daman" },
      { value: "diu", label: "Diu" }
    ]
  },
  {
    value: "delhi",
    label: "Delhi",
    district: [
      { value: "central delhi", label: "Central Delhi" },
      { value: "east delhi", label: "East Delhi" },
      { value: "new delhi", label: "New Delhi" },
      { value: "north delhi", label: "North Delhi" },
      { value: "north east delhi", label: "North East Delhi" },
      { value: "north west delhi", label: "North West Delhi" },
      { value: "shahdara", label: "Shahdara" },
      { value: "south delhi", label: "South Delhi" },
      { value: "south east delhi", label: "South East Delhi" },
      { value: "south west delhi", label: "South West Delhi" },
      { value: "west delhi", label: "West Delhi" }
    ]
  },
  {
    value: "jammu and kashmir",
    label: "Jammu and Kashmir",
    district: [
      { value: "anantnag", label: "Anantnag" },
      { value: "bandipora", label: "Bandipora" },
      { value: "baramulla", label: "Baramulla" },
      { value: "budgam", label: "Budgam" },
      { value: "doda", label: "Doda" },
      { value: "ganderbal", label: "Ganderbal" },
      { value: "jammu", label: "Jammu" },
      { value: "kathua", label: "Kathua" },
      { value: "kishtwar", label: "Kishtwar" },
      { value: "kulgam", label: "Kulgam" },
      { value: "kupwara", label: "Kupwara" },
      { value: "poonch", label: "Poonch" },
      { value: "pulwama", label: "Pulwama" },
      { value: "rajouri", label: "Rajouri" },
      { value: "ramban", label: "Ramban" },
      { value: "reasi", label: "Reasi" },
      { value: "samba", label: "Samba" },
      { value: "shopian", label: "Shopian" },
      { value: "srinagar", label: "Srinagar" },
      { value: "udhampur", label: "Udhampur" }
    ]
  },
  {
    value: "ladakh",
    label: "Ladakh",
    district: [
      { value: "kargil", label: "Kargil" },
      { value: "leh", label: "Leh" }
    ]
  },
  {
    value: "lakshadweep",
    label: "Lakshadweep",
    district: [
      { value: "lakshadweep", label: "Lakshadweep" }
    ]
  },
  {
    value: "puducherry",
    label: "Puducherry",
    district: [
      { value: "karaikal", label: "Karaikal" },
      { value: "mahe", label: "Mahe" },
      { value: "puducherry", label: "Puducherry" },
      { value: "yanam", label: "Yanam" }
    ]
  }
];



const AdvancedSearch = props => {

  const { showSearchOptions, setShowSearchOptions, setCandidates, itemsPerPage, currentPage, setTotalPages, setTotalCandidates, setLoading, filterOptions, setFilterOptions, jobId } = props

  const [inputBlock, setInputBlock] = useState({
    Keyword: {
      inputText: "",
      badges: [],
      boolean: false,
      mandatory: false,
      exclude: false,
      excludeText: "",
      excludeBadges: []
    },
    Company: {
      inputText: "",
      badges: [],
      boolean: false,
      searchCurrent: false,
      searchPrevious: false,
      mandatory: false,
      exclude: false,
      excludeText: "",
      excludeBadges: []
    },
    Designation: {
      inputText: "",
      badges: [],
      boolean: false,
      searchCurrent: false,
      searchPrevious: false,
      mandatory: false,
      exclude: false,
      excludeText: "",
      excludeBadges: []
    }
  })
  const [selectedEducation, setSelectedEducation] = useState([])
  const [selectedState, setSelectedState] = useState("")
  const [selectDistrict, setSelectedDistrict] = useState("")
  const [selectedCities, setSelectedCities] = useState([])
  const [enteredCity, setEnteredCity] = useState("")
  const [enteredRange, setEnteredRange] = useState({
    Age: {
      min: "",
      max: ""
    },
    Experience: {
      min: "",
      max: ""
    },
    "Expected Salary": {
      min: "",
      max: ""
    }
  })
  const [negotiableNoticePeriods, setNegotiableNoticePeriods] = useState([]);
  const [noticePeriods, setNoticePeriods] = useState([]);
  const [lastWorkingDays, setLastWorkingDays] = useState('');

  const [skills, setSkills] = useState([])
  const [skill, setSkill] = useState("")
  const [skillExperience, setSkillExperience] = useState({
    min: "",
    max: ""
  })

  const [resumeSearch, setResumeSearch] = useState(false)
  const [resumeAvailability, setResumeAvailability] = useState(false)
  const [relocation, setRelocation] = useState(false)
  const [salaryStatus, setSalaryStatus] = useState(false)
  const [excludeDisability, setExcludeDisability] = useState(false)

  const { BeURL, showAlert } = useContext(DContext)
  const [selectedGender, setSelectedGender] = useState('')
  const [includePreferredLocation, setIncludePreferredLocation] = useState(false)
  const [locationType, setLocationType] = useState('city');

  const [filterCount, setFilterCount] = useState(0)
  const navigate = useNavigate()


  const handleFilterClear = () => {

    setInputBlock({
      Keyword: {
        inputText: "",
        badges: [],
        boolean: false,
        mandatory: false,
        exclude: false,
        excludeText: "",
        excludeBadges: []
      },
      Company: {
        inputText: "",
        badges: [],
        boolean: false,
        mandatory: false,
        searchCurrent: false,
        searchPrevious: false,
        exclude: false,
        excludeText: "",
        excludeBadges: []
      },
      Designation: {
        inputText: "",
        badges: [],
        boolean: false,
        mandatory: false,
        searchCurrent: false,
        searchPrevious: false,
        exclude: false,
        excludeText: "",
        excludeBadges: []
      }
    })

    setEnteredRange({
      Age: {
        min: "",
        max: ""
      },
      Experience: {
        min: "",
        max: ""
      },
      "Expected Salary": {
        min: "",
        max: ""
      }
    })

    setLocationType("city")
    setSelectedCities([])
    setEnteredCity("")
    setSelectedState("")
    setSelectedDistrict("")

    setSelectedEducation([])
    setSelectedGender("")
    setNegotiableNoticePeriods([])

    setNoticePeriods([])
    setSkills([])
    setSkill("")
    setSkillExperience({
      min: "",
      max: ""
    })

    setIncludePreferredLocation(false)
    setResumeSearch(false)
    setResumeAvailability(false)
    setRelocation(false)
    setSalaryStatus(false)
    setExcludeDisability(false)

    setFilterCount(0)
  }

  // Add current skill + experience into skills[], then reset inputs
  const handleAddSkill = () => {
    if (skill.trim() === "") return;

    // You could validate min/max here if needed
    setSkills([
      ...skills,
      {
        skill: skill.trim(),
        min: skillExperience.min.trim(),
        max: skillExperience.max.trim(),
      },
    ]);

    // Clear inputs
    setSkill("");
    setSkillExperience({ min: "", max: "" });
  };

  // Remove a skill at given index
  const handleRemoveSkill = (indexToRemove) => {
    setSkills(skills.filter((_, idx) => idx !== indexToRemove));
  };

  const inputBlockKeys = [
    {
      label: "Keyword",
      placeholder: 'Type keyword(eg: software developer) and hit Enter button',
      booleanPlaceholder: 'Java AND (“Springboot” OR “spring boot”) NOT Wordpress'
    },
    {
      label: "Company",
      placeholder: 'Type company name(eg: Google) and hit Enter button',
      booleanPlaceholder: 'Google AND ("Microsoft" OR Amazon) NOT TCS'
    },
    {
      label: "Designation",
      placeholder: 'Type designation(eg: Software Engineer) and hit Enter button',
      booleanPlaceholder: '("Software Engineer" OR "Senior Software Engineer") AND ("Full Stack Developer" OR "MERN Stack Developer")'
    }
  ]

  const dependencyArray = [noticePeriods, salaryStatus, relocation, resumeAvailability, enteredRange, selectDistrict, selectedState, inputBlock, selectedEducation, resumeSearch, excludeDisability]

  useEffect(() => {
    let tempFilterCount = 0

    const tempArray = [salaryStatus, relocation, resumeAvailability, selectDistrict, selectedState, selectedGender, resumeSearch, excludeDisability]
    tempArray.forEach(item => {
      if (item) {
        tempFilterCount += 1
      }
    })

    const tempCollections = [selectedCities, selectedEducation, negotiableNoticePeriods, noticePeriods, skills]
    tempCollections.forEach(item => {
      if (item && Array.isArray(item) && item.length > 0)
        tempFilterCount += 1
    })

    if (enteredRange) {
      Object.entries(enteredRange).forEach(item => {
        if (Number(item[1].min) > 0 || Number(item[1].max) > 0) {
          tempFilterCount += 1
        }
      })
    }

    if (inputBlock) {
      Object.entries(inputBlock).forEach(item => {
        const tempBlock = item[1]
        const { boolean, exclude, excludeBadges, badges, inputText, mandatory, searchCurrent } = tempBlock
        if ((boolean && inputText) || (exclude && excludeBadges?.length > 0) || (badges?.length > 0 && !boolean) || ((inputText || badges) && searchCurrent)) {
          tempFilterCount += 1
        }
      })
    }

    setFilterCount(tempFilterCount)
  }, dependencyArray)

  useEffect(() => {

    const ipBlocks = ["Keyword", "Company", "Designation"]

    if (inputBlock) {
      for (const block of ipBlocks) {
        const tempBlock = inputBlock[block]
        if (tempBlock.mandatory) {
          if (tempBlock.badges.some(badge => badge.mandatory === false)) {
            setInputBlock(prev => {
              let tempInputBlock = { ...prev }
              tempInputBlock[block].mandatory = false
              return tempInputBlock
            })
          }
        }
        else if (!tempBlock.exclude && tempBlock?.excludeBadges.length > 0 && tempBlock.excludeText !== "") {
          setInputBlock(prev => {
            let tempInputBlock = { ...prev }
            tempInputBlock[block].excludeText = ""
            tempInputBlock[block].excludeBadges = []
            return tempInputBlock
          })
        }
        else {
          if (tempBlock?.badges.length > 0 && !(tempBlock?.badges.some(badge => !badge.mandatory))) {
            setInputBlock(prev => {
              let tempInputBlock = { ...prev }
              tempInputBlock[block].mandatory = true
              return tempInputBlock
            })
          }
        }
      }
    }
  }, [inputBlock])

  useEffect(() => {
    setSelectedCities([])
    setSelectedDistrict("")
    setSelectedState("")
  }, [locationType])

  const educationOptions = [
    {
      value: 'any',
      label: 'Any'
    },
    {
      value: 'engineer',
      label: 'Engineering(s)'
    },
    {
      value: 'computer',
      label: 'Computer(s)'
    },
    {
      value: 'embedded',
      label: 'Embedded'
    },
    {
      value: 'mechanic',
      label: 'Mechanical(s)'
    },
    {
      value: 'architect',
      label: 'Architect(s)'
    },
    {
      value: 'tech',
      label: 'Tech(s)'
    },
    {
      value: 'electr',
      label: 'Electronic(s)'
    },
    {
      value: 'auto',
      label: 'Auto(s)'
    },
    {
      value: 'design',
      label: 'Design'
    },
    {
      value: 'commerce',
      label: 'Commerce'
    },
    {
      value: 'tele',
      label: 'Tele(s)'
    }
  ]

  const genderOptions = [
    {
      value: 'any',
      label: 'Any'
    },
    {
      value: 'male',
      label: 'Male'
    },
    {
      value: 'female',
      label: 'Female'
    },
    {
      value: 'others',
      label: 'Others'
    }
  ]


  const negotiableNoticeOptions = [
    {
      value: 'immediate joiner',
      label: 'Immediate joiner'
    },
    {
      value: 'currently serving notice period',
      label: 'Currently serving notice period'
    },
    {
      value: '7 days',
      label: '7 days',
    },
    {
      value: '15 days',
      label: '15 days',
    },
    {
      value: '30 days',
      label: '30 days',
    },
    {
      value: '45 days',
      label: '45 days',
    },
    {
      value: '60 days',
      label: '60 days',
    },
    {
      value: '90 days',
      label: '90 days',
    }
  ];

  const stateOptions = indianStates ?
    indianStates.map(state => ({
      value: state.value,
      label: state.label
    }))
    : []

  const districtOptions = selectedState
    ? indianStates.find(state => state.value === selectedState.value)?.district.map(district => ({
      value: district.value,
      label: district.label
    }))
    : [];

  const noticeOptions = [
    'immediate joiner',
    'currently serving notice period',
    '7 days',
    '15 days',
    '30 days',
    '45 days',
    '60 days',
    '90 days',
  ];
  const toggleNotice = (opt, status) => {
    setNoticePeriods(prev => {
      let tempPrev = [...prev]

      if (status) {

        tempPrev = [...prev, opt]
      }
      else {
        tempPrev = prev.filter(n => n !== opt)
      }

      return tempPrev
    });
  };

  const handleInputTextChange = (prop, field, e) => {
    if (e.target.value !== "\n") {
      setInputBlock(prev => ({
        ...prev,
        [prop]: {
          ...prev[prop],
          [field]: e.target.value
        }
      }))
    }
  }

  const handleInputTextKeyDown = (prop, e) => {
    if (e.key === 'Enter' && e.target.value.trim() !== "" && !inputBlock[prop].boolean) {
      setInputBlock(prev => {
        let tempInputBlock = { ...prev }

        tempInputBlock[prop].inputText = ""
        tempInputBlock[prop].badges.push({
          keyword: e.target.value.trim(),
          mandatory: false
        })

        return tempInputBlock
      })
    }
    else if (e.key === 'Backspace' && e.target.value.trim() === "" && !inputBlock[prop].boolean) {
      setInputBlock(prev => {
        let tempInputBlock = { ...prev }
        tempInputBlock[prop].badges.pop()
        return tempInputBlock
      })
    }
  }

  const handleInputExcludeTextKeyDown = (prop, e) => {
    if (e.key === 'Enter' && e.target.value.trim() !== "" && inputBlock[prop].exclude) {
      setInputBlock(prev => {
        let tempInputBlock = { ...prev }

        tempInputBlock[prop].excludeText = ""
        tempInputBlock[prop].excludeBadges.push(e.target.value.trim())

        return tempInputBlock
      })
    }
    else if (e.key === 'Backspace' && e.target.value.trim() === "" && inputBlock[prop].exclude) {
      setInputBlock(prev => {
        let tempInputBlock = { ...prev }
        tempInputBlock[prop].excludeBadges.pop()
        return tempInputBlock
      })
    }
  }

  const removeInputTextBadge = (prop, badge) => {
    setInputBlock(prev => ({
      ...prev,
      [prop]: {
        ...prev[prop],
        badges: prev[prop].badges.filter((b, i) => i !== badge)
      }
    }))
  }

  const removeInputTextExcludeBadge = (prop, badge) => {
    setInputBlock(prev => ({
      ...prev,
      [prop]: {
        ...prev[prop],
        excludeBadges: prev[prop].excludeBadges.filter((b, i) => i !== badge)
      }
    }))
  }

  const handleBadgeMandatory = (prop, badgeIndex) => {
    setInputBlock(prev => {
      let tempInputBlock = { ...prev }
      tempInputBlock[prop].badges[badgeIndex].mandatory = !tempInputBlock[prop].badges[badgeIndex].mandatory
      return tempInputBlock
    })
  }

  const handleCheckboxChange = (prop, field, e) => {

    setInputBlock(prev => {
      let tempInputBlock = { ...prev }

      if (field === "mandatory") {
        if (e.target.checked) {
          tempInputBlock[prop].boolean = false
          tempInputBlock[prop].badges = tempInputBlock[prop].badges.map(badge => ({ ...badge, mandatory: true }))
        }
        else {
          tempInputBlock[prop].badges = tempInputBlock[prop].badges.map(badge => ({ ...badge, mandatory: false }))
        }
      }

      if (field === "boolean") {
        tempInputBlock[prop].mandatory = false
        tempInputBlock[prop].badges = []
      }

      tempInputBlock[prop][field] = e.target.checked

      return tempInputBlock
    })

  }

  // for the range display error

  const [errors, setErrors] = useState({
    Age: { min: "", max: "" },
    Experience: { min: "", max: "" },
    "Expected Salary": { min: "", max: "" }
  });

  const handleRangeChange = (Label, prop, e) => {

    if (Label === "Age") {
      if (/^\d+$/.test(e.target.value) || e.target.value === "") {
        setEnteredRange(prev => ({
          ...prev,
          [Label]: {
            ...prev[Label],
            [prop]: e.target.value
          }
        }))
      }
    }

    if (Label === 'Experience' || Label === 'Expected Salary') {
      if (/^\d{1,2}(\.\d?)?$/.test(e.target.value) || e.target.value === "") {

        setEnteredRange(prev => ({
          ...prev,
          [Label]: {
            ...prev[Label],
            [prop]: e.target.value
          }
        }))

      }
    }



    if (Label === 'Age') {
      if (prop === "min") {
        if (Number(e.target.value) < 18) {
          setErrors((prev) => ({
            ...prev,
            Age: {
              ...prev.Age,
              min: "Min age must be at least 18"
            }
          }));
        } else {
          setErrors((prev) => ({
            ...prev,
            Age: {
              ...prev.Age,
              min: ""
            }
          }));
        }
      }

      if (prop === "max") {
        if (Number(e.target.value) < enteredRange.Age.min) {
          setErrors((prev) => ({
            ...prev,
            Age: {
              ...prev.Age,
              max: `Max age must be ≥ ${enteredRange.Age.min}`
            }
          }));
        } else if (e.target.value === '') {
          setErrors((prev) => ({
            ...prev,
            Age: {
              ...prev.Age,
              max: ""
            }
          }));
        }

        else {
          setErrors((prev) => ({
            ...prev,
            Age: {
              ...prev.Age,
              max: ""
            }
          }));
        }
      }
    }

    if (Label === 'Experience' || Label === 'Expected Salary') {
      if (prop === "max") {
        if (Number(e.target.value) < enteredRange[Label].min) {
          setErrors((prev) => ({
            ...prev,
            [Label]: {
              ...prev[Label],
              [prop]: `Max ${Label} must be ≥ ${enteredRange[Label].min}`
            }
          }));
        } else if (e.target.value === "") {
          setErrors((prev) => ({
            ...prev,
            [Label]: {
              ...prev[Label],
              [prop]: ""
            }
          }));
        }
        else {
          setErrors((prev) => ({
            ...prev,
            [Label]: {
              ...prev[Label],
              [prop]: ""
            }
          }));
        }
      }
    }

  }

  // Show error for the Skill experience range
  const [skillExpErrors, setSkillExpErrors] = useState({
    min: "",
    max: ''
  })

  const fetchCandidates = async () => {
    setLoading(true)

    setFilterOptions({
      itemsPerPage: itemsPerPage || 10,
      currentPage: currentPage || 1,
      keyword: inputBlock?.Keyword || {},
      company: inputBlock?.Company || {},
      designation: inputBlock?.Designation || {},

      selectedEducation: selectedEducation || [],
      selectedGender: selectedGender?.value || "",

      locationType: locationType || "",
      selectedCities: selectedCities || [],
      selectedState: selectedState?.value || "",
      selectedDistrict: selectDistrict?.value || "",
      enteredCity: enteredCity || "",
      includePreferredLocation: includePreferredLocation || false,

      age: enteredRange?.Age || {},
      experience: enteredRange?.Experience || {},
      salary: enteredRange?.["Expected Salary"] || {},

      selectedNegotiableNoticePeriod: negotiableNoticePeriods || [],
      selectedNoticePeriod: noticePeriods || [],
      lastWorkingDay: lastWorkingDays || "",
      skills: skills || [],

      resumeSearch: resumeSearch || false,
      resumeAvailability: resumeAvailability || false,
      relocation: relocation || false,
      salaryStatus: salaryStatus || false,
      excludeDisability: excludeDisability || false
    })

    await fetchCandidatess(BeURL, filterOptions, setCandidates, setTotalPages, setTotalCandidates, setLoading, setShowSearchOptions, showAlert)

  }

  useEffect(() => {
    if (BeURL && itemsPerPage && currentPage) {
      setShowSearchOptions(true)
      fetchCandidates()
    }
  }, [BeURL, itemsPerPage, currentPage])

  const handlProSearch = () => {
    setShowSearchOptions(false)
    fetchCandidates()
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  const fetchedCities = async (e) => {
    const keyword = e.trim()
    if (keyword !== "" && keyword !== "\n" && keyword.length > 2 && BeURL) {

      try {
        const res = await fetch(`${BeURL}/fetch-cities`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          credentials: 'include',
          body: JSON.stringify({ keyword })
        })

        const data = await res.json()

        if (data?.success) {
          if (data?.cities.length > 0 && Array.isArray(data.cities)) {
            return data.cities.map(city => ({ value: city.toLowerCase(), label: city.toLowerCase() }))
          }
          else return []
        }
        else {

          return []
        }
      }
      catch (err) {
        console.log("Error in fetching Cities:", err)
        return []
      }
    }
  }

  const renderInputBlock = (Label, Placeholder, BooleanPlaceholder, index) => {

    return (
      <div className='w-full bg-white rounded-lg p-4 shadow h-[100%]' key={index}>
        <div className='w-100'>
          <div className="flex justify-between items-center gap-1 flex-wrap">
            <label className='block my-1 font-semibold label' htmlFor={Label}>{Label}</label>
            {
              Boolean(inputBlock[Label]?.inputText.length) && (!inputBlock[Label].boolean ?

                <span className="p-1 px-2 bg-yellow-200 text-xs text-yellow-700 rounded-lg m-1 flex gap-1 items-center"><TiWarningOutline /> Hit the Enter button</span>
                :

                <span className="p-1 px-2 bg-yellow-200 text-xs text-yellow-700 rounded-lg m-1 flex gap-1 items-center"><TiWarningOutline /> Boolean Format</span>
              )
            }
          </div>
          <div className="flex flex-wrap gap-2 border-[1px] border-slate-300 rounded-lg box-border mt-1">
            <div className="flex flex-wrap gap-2 items-start p-1 box-border overflow-auto max-w-full max-h-[150px] md:max-w-[30vw]">
              {
                inputBlock[Label]?.badges.length > 0 && inputBlock[Label]?.badges?.map((badge, i) => (
                  <span key={i} className="flex gap-1 items-center bg-blue-200 text-slate-900 font-medium px-2 rounded-lg w-max relative">
                    <span className="cursor-pointer hover:opacity-70" onClick={() => handleBadgeMandatory(Label, i)}>
                      {
                        badge?.mandatory ?
                          <FaStar />
                          : <FaRegStar />
                      }
                    </span>
                    <span className="w-max">{badge?.keyword}</span>
                    <span className="material-symbols-outlined text-[18px] cursor-pointer" onClick={() => removeInputTextBadge(Label, i)}>
                      close
                    </span>
                  </span>
                ))
              }
            </div>
            <textarea className='outline-none p-1 w-[100%] rounded-lg' value={inputBlock[Label].inputText} onKeyDown={(e) => handleInputTextKeyDown(Label, e)} onChange={(e) => handleInputTextChange(Label, "inputText", e)} placeholder={`${inputBlock[Label].boolean ? 'Eg: ' + BooleanPlaceholder : Placeholder}`} id={Label} />
          </div>
        </div>
        <div className="flex flex-wrap gap-3 items-center p-1 py-2">
          <div className='flex items-center'>
            <input className='mr-1' type='checkbox' id={`${Label}-boolean`} checked={inputBlock[Label].boolean} onChange={e => handleCheckboxChange(Label, "boolean", e)} />
            <label className='text-slate-700 text-sm' htmlFor={`${Label}-boolean`}>Enable Boolean</label>
          </div>
          <div className='flex items-center'>
            <input className='mr-1' type='checkbox' id={`${Label}-mandatory`} checked={inputBlock[Label].mandatory} onChange={e => handleCheckboxChange(Label, "mandatory", e)} />
            <label className='text-slate-700 text-sm' htmlFor={`${Label}-mandatory`}>Mark all Mandatory</label>
          </div>
          {
            (Label !== 'Keyword') &&
            <div className='flex items-center'>
              <input className='mr-1' type='checkbox' id={`${Label}-current`} checked={inputBlock[Label].searchCurrent} onChange={e => handleCheckboxChange(Label, "searchCurrent", e)} />
              <label className='text-slate-700 text-sm' htmlFor={`${Label}-current`}>Search in Current</label>
            </div>}
          {
            (Label !== 'Keyword') &&
            <div className='flex items-center'>
              <input className='mr-1' type='checkbox' id={`${Label}-previous`} checked={inputBlock[Label].searchPrevious} onChange={e => handleCheckboxChange(Label, "searchPrevious", e)} />
              <label className='text-slate-700 text-sm' htmlFor={`${Label}-previous`}>Search in Previous</label>
            </div>}
          <div className='flex items-center'>
            <input className='mr-1' type='checkbox' id={`${Label}-exclude`} checked={inputBlock[Label].exclude} onChange={e => handleCheckboxChange(Label, "exclude", e)} />
            <label className='text-slate-700 text-sm' htmlFor={`${Label}-exclude`}>Exclude {Label}</label>
          </div>
        </div>
        {
          inputBlock[Label].exclude &&
          <div className="w-100">
            <div className="flex justify-between items-center gap-1">
              <label className='block my-1 font-semibold text-slate-800' htmlFor={`${Label}-exclude-input`}>Excluding {Label}</label>

              {/* {
            Boolean(inputBlock[Label]?.excludeText.length) && (!inputBlock[Label].boolean  ?
            <div>
              <span className="p-1 bg-yellow-600 text-xs text-white rounded m-1">Hit the Enter button</span>
            </div> :
            <div>
              <span className="p-1 bg-yellow-600 text-xs text-white rounded m-1">Boolean Format</span>
            </div>
          )} */}

              {
                (Boolean(inputBlock[Label]?.excludeText.length) && inputBlock[Label]?.exclude) &&
                <span className="p-1 px-2 bg-yellow-200 text-xs text-yellow-700 rounded-lg m-1 flex gap-1 items-center"><TiWarningOutline /> Hit the Enter button</span>
              }
            </div>
            <div className="w-100 flex flex-wrap gap-2 border-[1px] border-slate-300 rounded-lg box-border">
              <div className="flex flex-wrap gap-2 items-start p-1 box-border overflow-auto max-w-full max-h-[150px] md:max-w-[30vw]">
                {
                  inputBlock[Label]?.excludeBadges.length > 0 && inputBlock[Label]?.excludeBadges?.map((badge, i) => (
                    <span key={i} className="flex gap-1 items-center bg-blue-200 text-slate-900 px-2 rounded-lg font-medium w-max">
                      <span className="w-max">{badge}</span>
                      <span className="material-symbols-outlined text-[18px] cursor-pointer" onClick={() => removeInputTextExcludeBadge(Label, i)}>
                        close
                      </span>
                    </span>
                  ))
                }
              </div>
              <textarea className='outline-none p-1 w-[100%] rounded-lg' value={inputBlock[Label].excludeText} onKeyDown={(e) => handleInputExcludeTextKeyDown(Label, e)} onChange={(e) => handleInputTextChange(Label, "excludeText", e)} placeholder={`${Placeholder}`} id={Label} />
            </div>
          </div>}
      </div>
    )

  }

  const renderRangeBlock = (Label, definition, min, max) => {
    return (
      <div className='w-full bg-white rounded-lg p-4 shadow h-[100%]'>
        <h4 className="mb-1 font-semibold label">{Label} {definition && <span className="font-normal text-sm text-slate-800">({definition})</span>}</h4>
        <div className='flex gap-2 w-full mt-3'>
          <div className="w-full">
            <label htmlFor={`${Label}-min`}>Min</label>
            <input id={`${Label}-min`} min={18} value={enteredRange?.[Label]?.min} onChange={e => handleRangeChange(Label, "min", e)} className='border p-[6px] rounded w-full' type='tel' placeholder={min ? `eg: ${min}` : 'min'} />

            {errors[Label]?.min && enteredRange[Label]?.min != '' && <p style={{ color: "red" }}>{errors[Label].min}</p>}
          </div>
          <div className="w-full">
            <label htmlFor={`${Label}-max`}>Max</label>
            <input id={`${Label}-max`} value={enteredRange?.[Label]?.max} onChange={e => handleRangeChange(Label, "max", e)} className='border p-[6px] rounded w-full' type='tel' placeholder={max ? `eg: ${max}` : 'max'} />
            {errors[Label]?.max && enteredRange[Label]?.max != '' && <p style={{ color: "red" }}>{errors[Label].max}</p>}
          </div>
        </div>
      </div>
    )
  }

  const renderCheckBox = (value, updater, Label) => {
    return (
      <div className=''>
        <input className='mr-2' id={Label} type='checkbox' checked={value} onChange={(e) => updater(e.target.checked)} />
        <label className='text-slate-800 italic' htmlFor={Label}>{Label}</label>
      </div>
    )
  }

  return (
    <div className='max-w-[96vw] mx-auto my-3'>
      <div className="flex justify-between items-center">
        {jobId && <div className='p-1 border-[1px] rounded-lg border-primary-500' onClick={() => navigate(-1)}
        ><TiArrowBack className='text-xl font-semibold ' /></div>}
        <button className="bg-primary-300 text-white px-2 py-1 rounded-lg flex justify-center items-center gap-2 mb-2" onClick={() => setShowSearchOptions(!showSearchOptions)}>
          <span className="material-symbols-outlined text-slate-200">
            tune
          </span>
          {showSearchOptions ? 'Applied' : 'Show'} Filters
          <span className="text-sm text-slate-800 bg-white px-1 rounded-full">{filterCount || 0}</span>
          <span className="material-symbols-outlined hover:bg-slate-800 rounded cursor-pointer" onClick={e => { e.stopPropagation(); handleFilterClear() }}>
            close
          </span>
        </button>
      </div>

      {
        showSearchOptions &&
        <div className="rounded-lg shadow-lg bg-slate-50 p-4 mt-1">
          <div className="flex flex-wrap justify-center items-stretch gap-2 md:gap-4 md:flex-nowrap mb-4 h-fit">
            {
              inputBlockKeys.map((item, i) => (
                <div className="w-full">
                  {renderInputBlock(item.label, item.placeholder, item.booleanPlaceholder, i)}
                </div>
              ))
            }
          </div>


          <div className="flex flex-wrap justify-center gap-2 md:gap-4 md:flex-nowrap my-4">
            {renderRangeBlock("Age", "", "18", "30")}
            {renderRangeBlock("Experience", "in years", "1.5", "50")}
            {renderRangeBlock("Expected Salary", "in LPA", "2.5", "45")}
          </div>

          {/* Toggle */}
          <div className="mt-4 flex justify-between gap-2">
            <div className="flex space-x-6 my-2 px-3">
              <label className="flex items-center space-x-2 cursor-pointer">
                <input
                  type="radio"
                  name="locationType"
                  value="city"
                  checked={locationType === 'city'}
                  onChange={() => setLocationType('city')}
                  className="accent-primary-400"
                />
                <span className="text-sm font-medium">City<span className="font-normal">(recommended)</span></span>
              </label>
              <label className="flex items-center space-x-2 cursor-pointer">
                <input
                  type="radio"
                  name="locationType"
                  value="region"
                  checked={locationType === 'region'}
                  onChange={() => setLocationType('region')}
                  className="accent-primary-400"
                />
                <span className="text-sm font-medium">State/District</span>
              </label>
            </div>
            {
              locationType === 'region' &&
              <div className="flex items-center space-x-2 text-slate-500 text-sm my-2 px-3">
                <p>Choosing "<b>State/District</b>" option may result in limited or less efficient search results.</p>
                <MdInfo className="text-red-500 text-lg" />
              </div>}
          </div>

          <div className="flex flex-wrap justify-center items-top gap-2 md:gap-4 md:flex-nowrap bg-white shadow rounded-xl p-3">
            <div className={`w-full ${locationType === "region" ? "cursor-not-allowed opacity-45" : ""}`}>
              <label htmlFor="city" className="font-semibold label">City</label>
              {/* <AsyncCreatableSelect
                id="city"
                isMulti
                // options={cities}
                defaultOptions
                loadOptions={fetchedCities}
                placeholder="Select or Enter Cities"
                value={selectedCities}
                inputValue={enteredCity}
                onInputChange={setEnteredCity}
                onChange={setSelectedCities}
                isClearable
                className="w-full border-slate-300 rounded-xl focus:ring-indigo-500 focus:border-indigo-500 my-1"
                isDisabled={locationType === "region"}
              /> */}
              <AsyncCreatableSelect
                id="city"
                isMulti
                defaultOptions
                loadOptions={fetchedCities}
                placeholder="Select or Enter Cities"
                value={selectedCities}
                inputValue={enteredCity}
                onInputChange={(input) => {
                  const filtered = input.replace(/[^a-zA-Z\s]/g, "");
                  setEnteredCity(filtered);
                  return filtered;
                }}
                onChange={setSelectedCities}
                isClearable
                className="w-full border-slate-300 rounded-xl focus:ring-indigo-500 focus:border-indigo-500 my-1"
                isDisabled={locationType === "region"}
              />
            </div>

            <div className={`w-full ${locationType === "city" ? "cursor-not-allowed opacity-45" : ""}`}>
              <label htmlFor="state" className="font-semibold label">State</label>
              <Select
                id="state"
                options={stateOptions}
                value={selectedState}
                onChange={(selected) => {
                  setSelectedState(selected);
                }}
                onInputChange={(inputValue) => {
                  // Only allow letters and spaces
                  if (/^[a-zA-Z\s\.]*$/.test(inputValue)) {
                    return inputValue;  // allow
                  } else {
                    return "";
                  }
                }}
                isClearable
                className="w-full border-slate-300 rounded-xl focus:ring-indigo-500 focus:border-indigo-500 my-1"
                isDisabled={locationType === "city"}
              />
            </div>

            <div className={`w-full ${locationType === "city" ? "cursor-not-allowed opacity-45" : ""}`}>
              <label htmlFor="district" className="font-semibold label">District</label>
              <Select
                id="district"
                options={districtOptions}
                value={selectDistrict}
                onChange={setSelectedDistrict}
                isClearable
                onInputChange={(inputValue) => {
                  // Only allow letters and spaces
                  if (/^[a-zA-Z\s\.]*$/.test(inputValue)) {
                    return inputValue;  // allow
                  } else {
                    return "";
                  }
                }}
                className="w-full border-slate-300 rounded-xl focus:ring-indigo-500 focus:border-indigo-500 my-1"
                isDisabled={!selectedState || locationType === "city"}  // Disable the role select if no department is selected
              />
            </div>

          </div>
          <div className="mb-4 px-3 mt-1">
            {renderCheckBox(includePreferredLocation, setIncludePreferredLocation, "Include Candidates who prefer this location")}
          </div>

          <div className="flex flex-wrap justify-center items-end gap-2 md:gap-4 md:flex-nowrap bg-white shadow my-4 rounded-xl p-3">

            <div className="w-full">
              <label htmlFor="education" className="font-semibold label">Education</label>
              <Select
                id="education"
                isMulti
                options={educationOptions}
                placeholder="Select or Enter Education"
                value={selectedEducation}
                onChange={setSelectedEducation}
                isClearable
                onInputChange={(inputValue) => {
                  // Only allow letters and spaces
                  if (/^[a-zA-Z\s\.]*$/.test(inputValue)) {
                    return inputValue;  // allow
                  } else {
                    return "";
                  }
                }}
                className="w-full border-slate-300 rounded-xl focus:ring-indigo-500 focus:border-indigo-500 my-1"
              />
            </div>

            <div className="w-full">
              <label htmlFor="gender" className="font-semibold label">Gender</label>
              <Select
                id="gender"
                options={genderOptions}
                value={selectedGender}
                onChange={setSelectedGender}
                isClearable
                isSearchable={false}
                className="w-full border-slate-300 rounded-xl focus:ring-indigo-500 focus:border-indigo-500 my-1"
              />
            </div>

            <div className="w-full">
              <label htmlFor="negotiable-notice" className="font-semibold label">Negotiable notice period</label>
              <Select
                id="negotiable-notice"
                isMulti
                options={negotiableNoticeOptions}
                value={negotiableNoticePeriods}
                onChange={setNegotiableNoticePeriods}
                isClearable
                className="w-full border-slate-300 rounded-xl focus:ring-indigo-500 focus:border-indigo-500 my-1"
              />
            </div>

          </div>

          <div className="my-4 flex flex-wrap justify-center items-stretch gap-2 md:gap-4 md:flex-nowrap">

            <div className="bg-white shadow rounded-xl p-4 w-full md:w-1/3">
              <h3 className="font-semibold mb-3 label">Notice Period</h3>
              <div className="flex flex-wrap gap-2 my-3">
                {noticeOptions.map(opt => (
                  <span
                    key={opt}
                    onClick={() => toggleNotice(opt, true)}
                    className={`flex items-center justify-center gap-2 rounded-lg font-medium px-3 py-1 ${noticePeriods.includes(opt) ? 'bg-blue-200 text-slate-900' : 'border border-gray-300 text-gray-700 cursor-pointer'}`}
                  >
                    {opt}
                    <span className={`material-symbols-outlined ${noticePeriods.includes(opt) ? 'cursor-pointer hover:text-slate-500 rounded' : 'cursor-default'} text-lg`}
                      onClick={(e) => {
                        e.stopPropagation(); // ✅ Prevent triggering outer click
                        toggleNotice(opt, false);
                      }}>
                      close
                    </span>
                  </span>
                ))}
              </div>
              {/* {(noticePeriods.includes('immediate joiner') || noticePeriods.includes('currently serving notice period')) && (
              <input type="date" value={lastWorkingDays} onChange={e => setLastWorkingDays(e.target.value)} placeholder="Last Working Days" className="border rounded p-2 mt-3 w-full max-w-full" />
            )} */}
            </div>

            <div className='p-4 flex flex-wrap justify-start items-center gap-4'>
              {/* {renderCheckBox(resumeSearch, setResumeSearch, "Search in Resume keywords")} */}
              {renderCheckBox(resumeAvailability, setResumeAvailability, "Only show candidates with resume")}
              {renderCheckBox(relocation, setRelocation, "Include candidate who're willing to relocate")}
              {renderCheckBox(salaryStatus, setSalaryStatus, "Include candidate who haven't mentioned salary")}
              {renderCheckBox(excludeDisability, setExcludeDisability, "Exclude candidate with disabilities")}
              {/* excludeDisability */}
            </div>

          </div>




          <div className='flex justify-center items-center'>
            <button className='px-4 py-1 rounded text-lg bg-primary-400 text-white' onClick={handlProSearch}>Search Results</button>
          </div>

        </div>}

    </div>
  )
}

export default AdvancedSearch;